import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NavigationService } from '../../../services/navigation.service';
import { NavigationDropdown, NavigationItem, NavigationLink } from '../../../models/navigation-item.interface';
import { NxIconService } from '../../../../services/icon.service';
import { NavBadgeService } from '../../../services/nav-badge.service';

@Component({
  selector: 'app-sidenav-item',
  imports: [
    RouterModule,
    MatIconModule,
    MatTooltipModule,
    MatBadgeModule
  ],
  templateUrl: './sidenav-item.html',
  styleUrl: './sidenav-item.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavItem {
  private navigationService = inject(NavigationService);
  /** Injetado apenas para garantir o registro dos SVGs customizados (icones svgIcon nos itens de menu). */
  private readonly _iconService = inject(NxIconService);
  private readonly navBadgeService = inject(NavBadgeService);

  item = input.required<NavigationItem>();
  expanded = input<boolean>(true);

  isExpanded = signal(false);

  isLink(item: NavigationItem): item is NavigationLink {
    return this.navigationService.isLink(item);
  }

  isDropdown(item: NavigationItem): item is NavigationDropdown {
    return this.navigationService.isDropdown(item);
  }

  toggleExpanded(): void {
    this.isExpanded.update(v => !v);
  }

  /** Resolve o valor do badge: dinamico via `NavBadgeService` quando `badgeKey` estiver definido, senao o `value` estatico. */
  badgeValue(item: NavigationLink): string {
    const badge = item.badge;
    if (!badge) return '';
    if (badge.badgeKey) return String(this.navBadgeService.count(badge.badgeKey)());
    return badge.value;
  }

  badgeHidden(item: NavigationLink): boolean {
    return !item.badge || this.badgeValue(item) === '0';
  }

  getBadgeClasses(badge: any): string[] {
    // Map old classes to semantic ones
    const colorMap: Record<string, string> = {
      'bg-badge-danger': 'bg-pmdf-danger text-pmdf-surface',
      'bg-badge-warning': 'bg-pmdf-warning text-pmdf-brand-navy',
      'bg-badge-success': 'bg-pmdf-success text-pmdf-surface',
      'bg-badge-info': 'bg-pmdf-primary text-pmdf-surface',
    };
    
    return [
      colorMap[badge.bgClass] || badge.bgClass,
      'text-pmdf-surface'
    ];
  }
}
